import { CyModule } from '@/store/modules/cyModule/types';
import router from '@/router';
import axios from '@/requests';


export const moduleAPI = {
    async listAllModule(): Promise<CyModule[]> {
        try {
            const res = await axios.get<CyModule[]>('/module/listAllModule');
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async listOwnModuleByUserId(userId: number): Promise<CyModule[]> {
        try {
            const res = await axios.get<CyModule[]>('/module/listOwnModuleByUserId', { userId: userId });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async listOwnModuleNameByUserId(userId: number): Promise<string[]> {
        try {
            const res = await axios.get<string[]>('/module/listAllModule', { userId: userId });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
}